<template>
  <settings-modal class="payment-retry-modal">
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <p class="subheading red--text text-darken-2 mb-0">Are you sure you want to retry this payment via SCT?</p>

    <template slot="actions">
      <v-btn
        id="reject"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentRetryModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        retryPaymentByAccountantApiRequest: new ApiRequest(PaymentApi.retrySepaInstantWithdrawalByAccountant),
        retryReturnPaymentByAccountantApiRequest: new ApiRequest(PaymentApi.retrySepaReturnByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      isReturn () {
        return this.modal.data.isReturn
      },
      heading () {
        return `Retry payment ${this.paymentId} via SCT?`
      },
      loading () {
        return this.isReturn
          ? this.retryReturnPaymentByAccountantApiRequest.loading
          : this.retryPaymentByAccountantApiRequest.loading
      },
      error () {
        return this.isReturn
          ? this.retryReturnPaymentByAccountantApiRequest.error
          : this.retryPaymentByAccountantApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        const apiRequest = this.isReturn
          ? this.retryReturnPaymentByAccountantApiRequest
          : this.retryPaymentByAccountantApiRequest

        apiRequest
          .execute(this.paymentId)
          .then(this.cancelSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      cancelSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'A new SCT request has been created.' }
          })
        }, 100)
      }
    }
  }
</script>

<style lang="scss">
.payment-retry-modal {
  &.settings-modal {
    .container {
      padding-bottom: 28px;
    }
  }
}
</style>
